// extracted by mini-css-extract-plugin
module.exports = {"row":"Adult_row__Gm54e","title":"Adult_title__1-Vra","subtitle":"Adult_subtitle__3oeQY","image":"Adult_image__CPPxg","description":"Adult_description__9mkrU"};